export interface AssetSegment {
  text: string;
  isReference: boolean;
}

export const ASSET_REFERENCE_COLOR = 'var(--ok)';
export const ASSET_REFERENCE_BG = 'rgba(94,230,184,0.15)';

export function splitAssetMentions(text: string, assetNames: Iterable<string>): AssetSegment[] {
  if (!text) return [];

  const names = new Set<string>();
  for (const name of assetNames) names.add(name.toLowerCase());
  if (names.size === 0) return [{ text, isReference: false }];

  const regex = /(^|[\s.,!?()])\/([A-Za-z0-9_-]+)/g;
  const segments: AssetSegment[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    const boundary = match[1];
    const name = match[2];
    if (!names.has(name.toLowerCase())) continue;

    const tokenStart = match.index + boundary.length;
    if (tokenStart > lastIndex) {
      segments.push({ text: text.slice(lastIndex, tokenStart), isReference: false });
    }
    const token = `/${name}`;
    segments.push({ text: token, isReference: true });
    lastIndex = tokenStart + token.length;
  }

  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex), isReference: false });
  }

  return segments.length > 0 ? segments : [{ text, isReference: false }];
}
